import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'
import { Conversation } from 'types/conversation'

const useActiveConversation = (): Conversation => {
  const { activeConversation: activeConversationId } = useSelector(state => state.conversations)
  const activeConversation = useSelector(state => (
    pathOr<Conversation>(null, ['conversations', 'conversations', activeConversationId, 'conversation'], state)
  ))
  return activeConversation
}

export default useActiveConversation
